export const isQuotaFull = (item) =>
  item?.is_quota_full === true || Number(item?.remaining_quota) <= 0;

export const getQuota = (item) => {
  const quota = Number(item?.quota);
  return Number.isFinite(quota) ? quota : null;
};

export const getEnrolledCount = (item) => {
  const enrolled = Number(item?.enrolled_count ?? item?.enrolled);
  return Number.isFinite(enrolled) ? enrolled : 0;
};

export const getRemainingQuota = (item) => {
  if (item?.remaining_quota != null && item.remaining_quota !== '') {
    const remaining = Number(item.remaining_quota);
    return Number.isFinite(remaining) ? Math.max(0, remaining) : 0;
  }

  if (item?.available_quota != null && item.available_quota !== '') {
    const available = Number(item.available_quota);
    return Number.isFinite(available) ? Math.max(0, available) : 0;
  }

  const quota = getQuota(item);
  if (quota == null) return null;
  return Math.max(0, quota - getEnrolledCount(item));
};

// The API's remaining_quota excludes draft recommendations, while enrolled
// already includes them. Use this for the number shown beside a batch.
export const getRemainingQuotaWithDrafts = (item) => {
  const quota = getQuota(item);
  return quota == null ? getRemainingQuota(item) : Math.max(0, quota - getEnrolledCount(item));
};

export const canEnroll = (item) => !isQuotaFull(item);
